import { unitDefault } from "@/settings/unitTypes";
export const PumpBB = {
  id: "2",
  name: "Bomba",
  mainClass: "Rotativos",
  subtype: "BB",
  variables: [
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "pumpHousing",
      groups: "general",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "cPbar11",
      groups: "planAPI11",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "fPbar11",
      groups: "planAPI11",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "fiTc23",
      groups: "planAPI23",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "shPbar23",
      groups: "planAPI23",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "cwTinC23",
      groups: "planAPI23",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "cwToutC23",
      groups: "planAPI23",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "shTc23",
      groups: "planAPI23",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "fiTcC32",
      groups: "planAPI32",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "fiTcC32",
      groups: "planAPI32",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "fiPbarC32",
      groups: "planAPI32",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "fiTcF32",
      groups: "planAPI32",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "fiPbarF32",
      groups: "planAPI32",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "cwOutTc52",
      groups: "planAPI52",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "cwInTc52",
      groups: "planAPI52",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "oilOutTc52",
      groups: "planAPI52",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "oilInTc52",
      groups: "planAPI52",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "shPbar52",
      groups: "planAPI52",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "pBar52",
      groups: "planAPI52",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "level52",
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "planAPI52",
      values: [10, 30, 80, 90]
    },
    {
      code: "cBpiTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "cBpoPbar53b",
      groups: "planAPI53b",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "cBpoTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "cCwInTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "cCwOutTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "cFwInTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "cFwOutTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "cRsPbar53b",
      groups: "planAPI53b",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "fBpiTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "fBpoTc53b",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI53b",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "fRsPbar53b",
      groups: "planAPI53b",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "iaPbar53b",
      groups: "planAPI53b",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "sysPbar53b",
      groups: "planAPI53b",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "tankLevel53b",
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "planAPI53b",
      values: [10, 30, 80, 90]
    },
    {
      code: "bpiTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "bpiPbar54",
      groups: "planAPI54",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "bpoTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "bpoPbar54",
      groups: "planAPI54",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "cwInTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "cwOutTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "flowLpm54",
      type: "flow",
      unit: unitDefault.flow.metric,
      groups: "planAPI54",
      values: [10, 30, 80, 90]
    },
    {
      code: "motorTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "levelL54",
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "planAPI54",
      values: [10, 30, 80, 90]
    },
    {
      code: "fbpiTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "fbpiPbar54",
      groups: "planAPI54",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "fbpoTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "fbpoPbar54",
      groups: "planAPI54",
      values: [50, 100, 200, 250],
      min: 0,
      max: 300
    },
    {
      code: "fcwInTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "fcwOutTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "fflowLpm54",
      type: "flow",
      unit: unitDefault.flow.metric,
      groups: "planAPI54",
      values: [10, 30, 80, 90]
    },
    {
      code: "fmotorTc54",
      type: "temperature",
      unit: unitDefault.temperature.metric,
      groups: "planAPI54",
      values: [100, 300, 800, 900],
      min: 0,
      max: 1000
    },
    {
      code: "flevelL54",
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "planAPI54",
      values: [10, 30, 80, 90]
    },
    {
      values: [150, 200, 240, 250],
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "pumpPressIn"
    },
    {
      values: [150, 200, 240, 250],
      type: "pressure",
      unit: unitDefault.pressure.metric,
      groups: "general",
      code: "pumpPressOut"
    },

    {
      values: [120, 150, 180, 200],
      type: "angularSpeed",

      unit: unitDefault.flow.metric,
      groups: "general",
      code: "pumpRotorSpeed"
    },
    {
      values: [60, 65, 80, 90],
      type: "percentage",
      unit: unitDefault.percentage.metric,
      groups: "general",
      code: "pumpOilLevel"
    },
    {
      values: [60, 65, 80, 90],
      type: "flow",
      unit: unitDefault.flow.metric,
      groups: "general",
      code: "pumpOutflow"
    }
  ],
  operationalValues: [
    {
      value: 1,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "pumpPressIn"
    },
    {
      value: 1,
      type: "pressure",
      unit: unitDefault.pressure.metric,
      code: "pumpPressOut"
    },
    {
      value: 1,
      type: "temperature",
      unit: unitDefault.temperature.metric,
      code: "pumpTempFluid"
    },
    {
      value: 1,
      type: "flow",
      unit: unitDefault.flow.metric,
      code: "pumpOutflow"
    },
    {
      value: 1,
      type: "angularSpeed",
      unit: unitDefault.flow.metric,
      code: "pumpRotorSpeed"
    },
    {
      value: 1,
      type: "percentage",
      unit: "percentage",
      code: "pumpOilLevel"
    }
  ]
};
